module.exports = {
      id: "heart-usage",
      viewBox: "0 0 22 20",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#heart-usage",
      toString: function () {
        return this.url;
      }
    }